import { Location } from '@angular/common';
import { Directive, inject, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subject, Subscription } from 'rxjs';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { environment } from '@env/environment';
import { AuthService, StorageService, ToastService } from '../services';
import { StockState } from '../interfaces';

@Directive()
export abstract class BaseComponent implements OnDestroy {
  protected readonly apiUrl: string = environment.apiUrl;
  protected readonly route = inject(ActivatedRoute);
  protected location: Location = inject(Location);
  protected router: Router = inject(Router);
  // protected toolbarService: ToolbarService = inject(ToolbarService);
  protected storageService: StorageService = inject(StorageService);
  protected authService: AuthService = inject(AuthService);
  protected toastService: ToastService = inject(ToastService);
  private _destroy$?: Subject<any>;
  protected apiCall$?: Subscription;
  protected dialogRef!: DynamicDialogRef | null;

  public isAdmin$: Observable<boolean> = this.authService.isAdmin$;

  public viewerOptions: any = {
    title: false,
    navbar: false,
    toolbar: {
      zoomIn: {
        show: 2,
        size: 'large',
      },
      zoomOut: {
        show: 2,
        size: 'large',
      },
      oneToOne: {
        show: 2,
        size: 'large',
      },
      reset: {
        show: 2,
        size: 'large',
      },
      prev: {
        show: 2,
        size: 'large',
      },
      next: {
        show: 2,
        size: 'large',
      },
      rotateLeft: {
        show: 2,
        size: 'large',
      },
      rotateRight: {
        show: 2,
        size: 'large',
      },
    },
  }

  get destroy$() {
    if (!this._destroy$) {
      // Perf optimization:
      // since this is likely used as base component everywhere
      // only construct a Subject instance if actually used
      this._destroy$ = new Subject();
    }
    return this._destroy$;
  }

  constructor() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false
  }

  goBack(): void {
    this.location.back();
  }

  ngOnDestroy() {
    if (this._destroy$) {
      this._destroy$.next(true);
      this._destroy$.complete();
    }
    if(this.apiCall$) {
      this.apiCall$.unsubscribe();
    }
    if (this.dialogRef) {
      this.dialogRef.close(null);
    }
  }
}
